import { createFileRoute } from '@tanstack/react-router';

import { FamilyHubSummary } from '~features/family-hub/ui/family-hub-summary';

const Component = () => {
  const { familyId } = Route.useParams();
  return <FamilyHubSummary familyId={familyId} />;
};

export const Route = createFileRoute(
  '/_auth/_layout/families/$familyId/summary',
)({
  component: Component,
});
